// Mobx
import { Store, VueStore, Watch } from "@mgs/ci2019-common/src/store";
// Api
import { Api } from "#/api";
import {
  RequestFilter,
  RequestFilterWithPageId,
} from "../../common/interfaces/conversionworld/RequestFilter";
import { ProductFilter } from "../../common/interfaces/conversionworld/ProductFilter";
import { Store as RootStore } from "./../index";
import ReadyToWork from "../../modules/conversionworld/filter_module/ready_to_work/ReadyToWork";
import Vue from "vue";

interface FilterTag {
  category: string;
  object: object;
}

@Store
export class ConversionWorldProductFilterState extends VueStore {
  public filterData: ProductFilter | null = null;

  public filterTags: FilterTag[] = [];

  public filter: RequestFilter = {
    query: "",
    type: undefined,
    branchen: [],
    countries: [],
    solutions: [],
    model_series: [],
    bodybuilder: [],
  };

  @Watch("filter", { deep: true })
  public onFilterChange() {
    this.updateFilterData();
  }

  get countryFilterCount() {
    if (this.filterData) {
      return this.filterData.countries.filter((x) => x.count > 0).length;
    }

    return 0;
  }

  get branchenFilterCount() {
    if (this.filterData) {
      return this.filterData.branchen.filter((x) => x.count > 0).length;
    }

    return 0;
  }

  get solutionFilterCount() {
    if (this.filterData) {
      return this.filterData.branchen
        .filter((x) => x.count > 0)
        .flatMap((x) => x.solutions.filter((s) => s.count > 0)).length;
    }

    return 0;
  }

  get bodybuilderFilterCount() {
    if (this.filterData) {
      return this.filterData.bodybuilder.filter((x) => x.count > 0).length;
    }

    return 0;
  }

  get modelSeriesFilterCount() {
    if (this.filterData) {
      return this.filterData.model_series.filter((x) => x.count > 0).length;
    }

    return 0;
  }

  public get filterWithPageId(): RequestFilterWithPageId {
    let filter = Object.assign({}, this.filter) as RequestFilterWithPageId;
    filter.page_id = RootStore.instance.page.page!.id;

    return filter;
  }

  public async updateFilterData() {
    this.filterData = await Api.conversionWorldService.getFilters(
      this.filterWithPageId
    );
  }

  public addFilterTag(category: string, object: object) {
    if (category === "model_series") {
      let model = object["model"];
      let variant = object["variant"];

      this.filter.model_series.push({
        model: model["id"],
        variant: variant["id"],
      });
      this.filterTags.push({
        category: category,
        object: {
          id: model["id"] + "__" + variant["id"],
          name: variant["name"],
        },
      });
    } else if (category === "ready_to_work") {
      Vue.set(this.filter, category, { active: true });
      if (object && object["location"]) {
        this.filter.ready_to_work!.location = object["location"];
      }
      if (object && object["radius"]) {
        this.filter.ready_to_work!.radius = object["radius"];
      }
      this.filterTags.push({
        category,
        object: {
          name: object["name"],
        },
      });
    } else {
      this.filter[category].push(object["id"]);
      this.filterTags.push({
        category,
        object,
      });
    }
  }

  public removeFilterTag(category: string, object: object) {
    if (category === "model_series") {
      let modelId, variantId;

      if (object["model"] && object["variant"]) {
        modelId = object["model"]["id"];
        variantId = object["variant"]["id"];
      } else {
        let ids = object["id"].split("__");
        modelId = ids[0];
        variantId = ids[1];
      }

      this.filter.model_series = this.filter.model_series
        .slice()
        .filter((x) => !(x.model == modelId && x.variant == variantId));

      this.filterTags = this.filterTags.filter((t) => {
        return !(
          t.category == category && t.object["id"] == modelId + "__" + variantId
        );
      });
    } else if (category === "ready_to_work") {
      this.filter[category] = undefined;
      this.filterTags = this.filterTags.filter((t) => {
        return !(t.category == category);
      });
    } else {
      this.filterTags = this.filterTags.filter((t) => {
        return !(t.category == category && t.object["id"] == object["id"]);
      });

      this.filter[category] = this.filter[category].filter(
        (x) => x != object["id"]
      );
    }
  }

  public resetFilterTags() {
    this.filterTags = [];
    this.filter = {
      query: this.filter.query,
      branchen: [],
      countries: [],
      solutions: [],
      model_series: [],
      bodybuilder: [],
    };
    this.updateFilterData();
  }
}
